import type { MfaEnrollmentOffer } from '../../api/auth';

export type AvailableFactor = MfaEnrollmentOffer['available_factors'][number];

export interface FactorCopy {
  selectorLabel: string;
  icon: 'phone' | 'email';
  offerTitle: string;
  offerSubtitle: string;
  confirmTitle: string;
  confirmBody: string;
}

// Single source of truth for factor-specific copy across the offer and confirm screens - a
// Record over every element of the real backend union means adding a new factor type upstream
// (e.g. 'totp') fails this at compile time until its copy is added here, and both screens pick
// it up automatically with no other code changes.
export const FACTOR_COPY: Record<AvailableFactor, FactorCopy> = {
  phone: {
    selectorLabel: 'Text message',
    icon: 'phone',
    offerTitle: 'Add your phone number',
    offerSubtitle: "We'll text a code to confirm your number and help keep your account secure.",
    confirmTitle: 'Phone number verified',
    confirmBody: 'Your phone number was verified and saved to your account. You can update it anytime in your profile settings.',
  },
};
